module.exports = "<div class=\"pie-container\">\r\n  <div class=\"pie-outer-layer centralise-element\"></div>\r\n  <canvas baseChart #pieChart class=\"canvas-container\"\r\n          [data]=\"pieChartData\"         \r\n          [chartType]=\"pieChartType\"     \r\n          [legend]=\"pieLegend\" \r\n          [colors]=\"pieColor\"     \r\n          [options]=\"options\"  \r\n  ></canvas>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/progress-chart/progress-chart.component.html
// module id = ../../../../../src/app/core/components/progress-chart/progress-chart.component.html
// module chunks = main